import { render, staticRenderFns } from "./AppApiManageModal.vue?vue&type=template&id=389466fc"
import script from "./AppApiManageModal.vue?vue&type=script&lang=js"
export * from "./AppApiManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports